import Sticky from "react-stickynode"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import dynamic from "next/dynamic"
import MetaData from "@/common/components/MetaData"
import SectionLine from "@/common/components/_UI/SectionLine"

import WalletExtensionDark from "@/common/assets/image/products/icons/WalletExtensionDark.svg"

const NavbarNew = dynamic(import("@/containers/common/NavbarNew"))

import { DarkBGWrapper, LayoutWrapper } from "@/common/components/LayoutStyle"
import Description from "@/common/components/Description"
import ProductCTA from "@/common/components/ProductCTA"
import ProductViewMore from "@/common/components/ProductViewMore"
import { ProductBanner } from "@/common/components/ProductBanner"
import { ProductNames, SolutionNames } from "@/common/data/Products"
import Footer from "@/containers/common/FooterNew"

const WalletExtensionPage = () => {
  const { t } = useTranslation(["walletExtension"])
  const { t: commonT } = useTranslation(["common"])

  return (
    <>
      <MetaData
        title={t("meta.title")}
        description={t("meta.description")}
        url={t("meta.url")}
        image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
        languageAlternates={[
          {
            hrefLang: "en-US",
            href: "https://www.kryptogo.com/products/wallet-extension"
          },
          {
            hrefLang: "zh-TW",
            href: "https://www.kryptogo.com/tw/products/wallet-extension"
          },
          {
            hrefLang: "zh-CN",
            href: "https://www.kryptogo.com/cn/products/wallet-extension"
          },
          {
            hrefLang: "ja-JP",
            href: "https://www.kryptogo.com/ja/products/wallet-extension"
          }
        ]}
      />

      <Sticky top={0} innerZ={1000} activeClass="sticky-active">
        <NavbarNew />
      </Sticky>
      <DarkBGWrapper></DarkBGWrapper>
      <LayoutWrapper>
        <ProductBanner
          icon={WalletExtensionDark.src}
          bannerType={ProductNames.WalletExtension}
          title={t("Banner.productName")}
          titleh1={t("Banner.title")}
          description={t("Banner.description")}
          primaryButton={{
            content: t("Banner.button"),
            href: "https://chrome.google.com/webstore/detail/kryptogo-crypto-nft-walle/bgaihnkooadagpjddlcaleaopmkjadfl"
          }}
        />
        <SectionLine />
        <Description
          items={[
            {
              titles: [{ text: t("Desc.1.title") }],
              content: t("Desc.1.content")
            },
            {
              titles: [{ text: t("Desc.2.title") }],
              content: t("Desc.2.content")
            },
            {
              titles: [{ text: t("Desc.3.title") }],
              content: t("Desc.3.content")
            },
            {
              titles: [{ text: t("Desc.4.title") }],
              content: t("Desc.4.content")
            },
            {
              titles: [{ text: t("Desc.5.title") }],
              content: t("Desc.5.content")
            }
          ]}
        />
        <ProductCTA
          title={t("CTA.title")}
          primaryButton={{
            text: t("CTA.button"),
            href: "https://chrome.google.com/webstore/detail/kryptogo-crypto-nft-walle/bgaihnkooadagpjddlcaleaopmkjadfl",
            target: "_blank"
          }}
        />
        <ProductViewMore
          commonT={commonT}
          title={commonT("ViewMore.title")}
          tab={[
            {
              name: commonT("ViewMore.products"),
              content: [
                ProductNames.WalletApplication,
                ProductNames.WalletBuilder,
                ProductNames.WalletAPI
              ]
            },
            {
              name: commonT("ViewMore.solutions"),
              content: [SolutionNames.GameFi, SolutionNames.Defi]
            }
          ]}
          actionText={commonT("ViewMore.allProducts")}
        ></ProductViewMore>
        <Footer />
      </LayoutWrapper>
    </>
  )
}

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "common",
      "contactUs",
      "walletExtension"
    ]))
  }
})

export default WalletExtensionPage
